import * as yup from 'yup';
import {
  countTabImages,
  GALLERY_TAB_CODES,
  MAX_IMAGES_PER_TAB,
  MAX_SECTIONS_CONFIG_LENGTH,
  serializeSections
} from './constants';


const sectionsSchema = yup.array().of(
  yup.object().shape({
    name: yup.string().trim().required('Section name is required')
  })
)
  .test(
    'tab-images-limit',
    `A tab can have at most ${MAX_IMAGES_PER_TAB} images in total`,
    (sections) => countTabImages(sections) <= MAX_IMAGES_PER_TAB
  )
  .test(
    'sections-config-size',
    'This tab contains too much content to be saved. Please remove some sections, items or images.',
    (sections) => {
      try {
        return serializeSections(sections || []).length <= MAX_SECTIONS_CONFIG_LENGTH;
      } catch (e) {
        return true;
      }
    }
  );

export const validationSchema = yup.object().shape({
  surgeons: yup.array().of(
    yup.object().shape({
      name: yup.string().trim().required('Surgeon name is required')
    })
  ),
  tabs: yup.object().shape(
    GALLERY_TAB_CODES.reduce((shape, tabCode) => ({
      ...shape,
      [tabCode]: yup.object().shape({sections: sectionsSchema})
    }), {})
  )
});
